import { Button } from '@/components/ui/button';
import React from 'react';

import { Modal } from '@/components/Modal';

interface DeleteAccountModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
  accountName: string;
  isPending?: boolean;
}

export const DeleteAccountModal: React.FC<DeleteAccountModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  accountName,
  isPending = false,
}) => {
  return (
    <Modal
      style="dialog"
      title={''}
      hideClose
      hideFooter
      open={isOpen}
      onClose={onClose}
      className="flex flex-col items-center gap-6 py-6"
    >
      <div className="text-center">
        <h1 className="text-lg font-bold">Delete Account</h1>
        <p className="text-chariot-text-primary mt-1 font-semibold">
          {accountName}
        </p>
      </div>
      <div className="text-chariot-text-secondary text-center text-sm">
        <p>
          Deleting this account is a permanent action that cannot be reversed.
        </p>
      </div>
      <div className="flex gap-3">
        <Button variant="ghost" onClick={onClose}>Cancel</Button>
        <Button
          disabled={isPending}
          className="border-chariot-stroke-critical bg-chariot-status-critical hover:bg-chariot-status-critical/80 border disabled:border-transparent"
          onClick={onConfirm}
        >Delete Account</Button>
      </div>
    </Modal>
  );
};
